import service from '@/api/tenant';

export const state = {
    list: [],
    current: null,
    // A tenant-kötött appon (tenant.* domain) a backend a domain intézmény-
    // HALMAZÁT adja vissza a `list`-ben (confined) és a `bound_tenants` tömbben.
    // Egy elem → statikus név; több elem → a váltóban válthat köztük. Kötetlen
    // appon a `list` a user tenantjai, a `bound` üres.
    bound: [],
    // A platform-szintű felhasználó intézményi adatot csak belépve lát: nála a váltó
    // belépés és kilépés, és a `current` null, amíg nem lépett be.
    requiresEntry: false,
    // Belépve alapból csak olvasás; ez az írás lejárata (ISO), ha be van kapcsolva.
    writeUntil: null,
    loading: false,
    loaded: false,
};

export const getters = {
    list: (state) => JSON.parse(JSON.stringify(state.list)),
    current: (state) => state.current,
    currentTenant: (state) => state.list.find(t => t.id === state.current) || null,
    loading: (state) => !!state.loading,
    loaded: (state) => !!state.loaded,
    // A domainhez kötött intézmény-halmaz (üres, ha nem kötött).
    bound: (state) => state.bound,
    isBound: (state) => state.bound.length > 0,
    requiresEntry: (state) => !!state.requiresEntry,
    writeUntil: (state) => state.writeUntil,
    // Van-e miből váltani: a backend a `list`-ben már a MEGFELELŐ halmazt adja
    // (kötött appon a domain-halmaz ∩ user; kötetlenen a user tenantjai), így a
    // váltó egyszerűen akkor látszik, ha >1 elem van — kötött multi-domainen is.
    hasMultiple: (state) => state.list.length > 1,
};

export const mutations = {
    SET_LIST(state, list) { state.list = list; },
    SET_CURRENT(state, id) { state.current = id; },
    SET_BOUND(state, ids) { state.bound = Array.isArray(ids) ? ids : []; },
    SET_REQUIRES_ENTRY(state, value) { state.requiresEntry = !!value; },
    SET_WRITE_UNTIL(state, value) { state.writeUntil = value || null; },
    SET_LOADING(state, value) { state.loading = !!value; },
    SET_LOADED(state, value) { state.loaded = !!value; },
};

export const actions = {
    fetchMine({ commit, state }, force = false) {
        if (state.loaded && !force) {
            return Promise.resolve({ data: state.list, current: state.current, bound_tenants: state.bound });
        }
        commit('SET_LOADING', true);
        return service.mine().then(response => {
            commit('SET_LIST', response.data || []);
            commit('SET_CURRENT', response.current ?? null);
            commit('SET_BOUND', response.bound_tenants ?? []);
            commit('SET_REQUIRES_ENTRY', response.requires_entry);
            commit('SET_WRITE_UNTIL', response.write_until);
            commit('SET_LOADED', true);
            commit('SET_LOADING', false);
            return response;
        }).catch(e => {
            commit('SET_LOADING', false);
            throw e;
        });
    },

    setCurrent({ commit, state }, tenantId) {
        commit('SET_LOADING', true);
        return service.setCurrent(tenantId).then(response => {
            // másik intézménybe lépve az írás nem öröklődik (ugyanabba újra: a szerver megtartja)
            if ((response.current ?? tenantId) !== state.current) commit('SET_WRITE_UNTIL', null);
            commit('SET_CURRENT', response.current ?? tenantId);
            commit('SET_LOADING', false);
            return response;
        }).catch(e => {
            commit('SET_LOADING', false);
            throw e;
        });
    },

    enableWrite({ commit }, { reason, minutes }) {
        return service.enableWrite(reason, minutes).then(response => {
            commit('SET_WRITE_UNTIL', response.write_until);
            return response;
        });
    },

    disableWrite({ commit }) {
        return service.disableWrite().then(response => {
            commit('SET_WRITE_UNTIL', null);
            return response;
        });
    },

    setView(_, view) {
        return service.setView(view);
    },

    leave({ commit }) {
        commit('SET_LOADING', true);
        return service.leave().then(response => {
            commit('SET_CURRENT', null);
            commit('SET_WRITE_UNTIL', null);
            commit('SET_LOADING', false);
            return response;
        }).catch(e => {
            commit('SET_LOADING', false);
            throw e;
        });
    },
};
